import { useScreenSizes } from '@che-ins-ui/theme';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/components/routes';
import { BREAKPOINTS } from '@/styles/breakpoints';
export const useIsMobileViewInsuranceForm = () => {
    const { width } = useScreenSizes();
    return width <= BREAKPOINTS.lg;
};
export const useIsMobileInputSuggestions = () => {
    const { width } = useScreenSizes();
    return width <= BREAKPOINTS.md;
};
export const useNavigateToMainPage = () => {
    const navigate = useNavigate();
    return useCallback(() => {
        navigate(ROUTES.main);
    }, [navigate]);
};
